import { useTheme } from '@mui/material';
import cn from 'classnames';
import React, { useMemo } from 'react';

import { Drawer } from '../../components';
import useWindowSize from '../../hooks/useWindowSize';
import { DrawerAnimationDirectionEnum } from '../../types/shell';

import styles from './AutomationSidebar.module.scss';

interface IProps {
  onClose: () => void;
  trigger: boolean;
  children?: React.ReactNode;
  withPortal?: boolean;
  withOwnLayout?: boolean;
  size?: 'sm';
}

const AutomationSidebar: React.FC<IProps> = ({
  trigger,
  onClose,
  children,
  withPortal,
  withOwnLayout = false,
  size,
}) => {
  const { sass: variables } = useTheme();
  const { mobile, HD } = useWindowSize();

  const from = useMemo(
    () => (mobile ? variables.automationSidebarMinHeight : variables.automationSidebarMinWidth),
    [mobile, variables],
  );

  const to = useMemo(() => {
    if (mobile) {
      return variables.automationSidebarMaxHeight;
    }

    if (size === 'sm') {
      return variables.automationSidebarSmWidth;
    }

    if (HD) {
      return variables.automationSidebarMaxWidthHD;
    }

    return variables.automationSidebarMaxWidthFullHD;
  }, [mobile, HD, size, variables]);

  return (
    <Drawer
      className={cn(styles.container, { [styles.ownLayout]: withOwnLayout })}
      direction={mobile ? DrawerAnimationDirectionEnum.Vertically : DrawerAnimationDirectionEnum.Horizontally}
      from={from}
      to={to}
      trigger={trigger}
      onClose={onClose}
      withOverlay
      withPortal={withPortal}
      overlayClassName={styles.overlay}
    >
      {!withOwnLayout && (
        <div className={styles.closeBtnContainer}>
          <button className={styles.closeBtn} onClick={onClose} />
        </div>
      )}
      {children}
    </Drawer>
  );
};

export default AutomationSidebar;
